import { TreatmentWithConfig, TreatmentsWithConfig } from '@splitsoftware/splitio/types/splitio';
import { getHomeLoansDashboardRuntimeConfig } from 'src/services/config/getHomeLoansDashboardRuntimeConfig';
import { getParsedLocalStorageItem, getRawLocalStorageItem } from 'src/services/storage/local';
import { ActiveSplitExperiment } from '../client/ongoingExperiments';

export const getExperiment = (
    name: ActiveSplitExperiment,
    serverSideExperiments?: TreatmentsWithConfig
): TreatmentWithConfig | null => {
    const { publicRuntimeConfig } = getHomeLoansDashboardRuntimeConfig();
    const clientSideLiveValue = globalThis.zhlExperiments?.[name] ?? null;
    const serverSideLiveValue = serverSideExperiments?.[name] ?? null;
    const liveValue = serverSideLiveValue ?? clientSideLiveValue;

    if (!publicRuntimeConfig.isLowerEnvironment) {
        return liveValue;
    }

    const localStorageValue = getRawLocalStorageItem(`${name}_override`);
    const localStorageOverridenValue: TreatmentWithConfig | null = localStorageValue
        ? { treatment: localStorageValue, config: null }
        : null;
    const emptyTreatments = {} as TreatmentsWithConfig;
    const cypressDefinedLocalExperiments = globalThis.Cypress
        ? getParsedLocalStorageItem<TreatmentsWithConfig>('localExperiments') ?? emptyTreatments
        : emptyTreatments;

    const cypressOverridenValue: TreatmentWithConfig | null = cypressDefinedLocalExperiments[name] ?? null;

    return cypressOverridenValue ?? localStorageOverridenValue ?? liveValue;
};
